module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/discovery-ui/images/app-store-badges/apple-app-store-es-ab05f44b16c3c97af7b3ac8d2f46d8bf.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/discovery-ui/images/app-store-badges/apple-app-store-es.svg
// module id = JI+O
// module chunks = 24